/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import {
	Button,
	Modal,
	Dialog,
	Slide
} from '@material-ui/core';
import { LockOutlined } from '@material-ui/icons';
import { GoogleLogin } from 'react-google-login';
import { useTheme } from '@material-ui/core/styles';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import renderHTML from 'react-render-html';
import { useForm } from 'react-hook-form';
import { loadStripe } from '@stripe/stripe-js';

import AjaxHelper from '../../../common/AjaxHelper';
import SessionHelper from '../../../common/SessionHelper';
import TranslationHelper from '../../../common/TranslationHelper';
import UIHelper from '../../../common/UIHelper';
import ReactHookFormInput from '../../common/input/ReactHookFormInput';
import DividerWithText from '../../common/DividerWithText';
import SignUpForm from '../components/SignUpForm';
import ProfileMenu from '../components/ProfileMenu';

import '../../../css/components/signup/signup.css';

const SignUp = (props) => {
	const { openModal, mobileView } = props;
	const [openSignIn, setOpenSignIn] = useState(openModal || false);
	const [toggleSignUp, setToggleSignUp] = useState(false);
	const [toggleForgotPass, setToggleForgotPass] = useState(false);
	const [openPolicy, setOpenPolicy] = useState(false);
	const [policyName, setPolicyName] = useState(null);
	const [stateObj, setStateObj] = useState({
		googleOauthAPIKey: '',
		facebookAPI: '',
		termsAndConditions: '',
		privacyPolices: '',
		loginLayout: 'default',
		verificationRequired: false,
		facebookEnabled: true,
		googleEnabled: true,
		stripeKey: null
	});
	const { handleSubmit, ...useFormHooks } = useForm();
	const theme = useTheme();
	// console.log('stateObj.stripeKey : ', stateObj.stripeKey);
	const stripePromise = (stateObj.stripeKey) ? loadStripe(stateObj.stripeKey) : null;
	const inputFieldsSignIn = [
		{
			name: 'signInEmail',
			label: 'Email Address',
			type: 'text',
			validation: { required: true },
			defaultValue: '',
			fullWidth: true,
			style: { margin: '10px 0px' },
			variant: 'outlined',
		},
		{
			name: 'signInPass',
			label: 'Password',
			type: 'password',
			validation: { required: true },
			defaultValue: '',
			fullWidth: true,
			style: { margin: '10px 0px' },
			variant: 'outlined',
		}
	];

	const handleOpenSignIn = () => {
		setOpenSignIn(true);
	};

	const handleCloseSignIn = () => {
		setOpenSignIn(false);
	};

	const handleOpenPolicy = (e, name) => {
		setOpenPolicy(true);
		setPolicyName(name);
	};

	const handleClosePolicy = () => {
		setOpenPolicy(false);
	};

	const handleSignIn = (data) => {
		SessionHelper.saveSessionUser(data);
		setStateObj((prevState) => ({
			...prevState,
			loggedIn: true,
			username: data.username,
			email: data.email
		}));
		handleCloseSignIn();
		window.location.reload();
	};

	const handleSignOut = async () => {
		setStateObj((prevState) => ({
			...prevState,
			loggedIn: false,
			username: null,
			email: null
		}));
		await AjaxHelper.invokeServerAPIPromise('/api/logout');
		SessionHelper.removeUser();
		window.location = '/';
	};

	const onSignUp = (data) => {
		const name = stateObj.paymentEnabled
        || (stateObj.customerAttributes && stateObj.customerAttributes[0])
			? data.data.signUpName
			: data.signUpName;
		const email = stateObj.paymentEnabled || (stateObj.customerAttributes && stateObj.customerAttributes[0])
			? data.data.signUpEmail.toLowerCase()
			: data.signUpEmail.toLowerCase();
		const password = stateObj.paymentEnabled || (stateObj.customerAttributes && stateObj.customerAttributes[0])
			? data.data.signUpPass
			: data.signUpPass;
		const token = stateObj.paymentEnabled ? data.token : null;
		const customAttributes = (stateObj.customerAttributes && stateObj.customerAttributes[0])
			? data.data.customAttributes
			: [];

		const handleDisabled = () => {
			data.setDisabled(true);
		};

		const param = {
			email,
			username: email,
			password,
			name,
			token,
			customAttributes
		};

		AjaxHelper.invokeServerAPI('/api/register', param, (err, data) => {
			if (err) {
				if (err.message === 'A user with the given username is already registered') {
					UIHelper.showErrorMessage(TranslationHelper.getValue('customer_account.login.accountExisted'));
				} else {
					UIHelper.showErrorMessage(TranslationHelper.getValue('customer_account.login.servererror'));
				}
			} else {
				handleDisabled();
				if (!stateObj.verificationRequired) {
					onSignIn({ signInEmail: param.username, signInPass: param.password });
				} else {
					UIHelper.showInfoMessage(TranslationHelper.getValue('signup.successmessage.withverification'));
					handleCloseSignIn();
				}
			}
		});
	};

	const onSignIn = (signInData) => {
		const username = signInData.signInEmail.toLowerCase();
		const password = signInData.signInPass;

		const param = {
			username,
			password
		};

		AjaxHelper.invokeServerAPI('/api/login', param, async (err, data) => {
			if (err) {
				UIHelper.showErrorMessage(TranslationHelper.getValue('customer_account.login.error'));
			} else if (data.err === 'unVerified') {
				UIHelper.showInfoMessage(TranslationHelper.getValue('customer_account.login.verify'));
			} else {
				if (stateObj.adminAppURL) {
					try {
						await AjaxHelper.postAPIWithCorsMode(`${stateObj.adminAppURL}/int/login`, param);
					} catch (e) {
						console.log('e', e);
					}
				}
				handleSignIn(data);
			}
		});
	};

	const onForgotPass = (data) => {
		const param = {
			email: data.forgotPassEmail.toLowerCase()
		};

		AjaxHelper.invokeServerAPI('/api/forgot', param, (err, data) => {
			if (err) {
				UIHelper.showErrorMessage(TranslationHelper.getValue('customer_account.recoverPassword.error'));
			} else {
				UIHelper.showInfoMessage(TranslationHelper.getValue('customer_account.recoverPassword.checkEmail'));
			}
		});

		handleCloseSignIn();
	};

	const onFacebookSignIn = (req) => {
		if (req.email) {
			const param = {
				email: req.email,
				username: req.email,
				password: req.accessToken,
				name: req.name,
				avatar: (req.picture && req.picture.data) ? req.picture.data.url
					: `http://graph.facebook.com/${req.id}/picture?type=normal`,
				type: 'facebook',
				google: {},
				facebook: req
			};
			socialSignIn(param);
		}
	};

	const onGoogleLogin = (req) => {
		if (req.profileObj) {
			const param = {
				email: req.profileObj.email,
				username: req.profileObj.email,
				password: req.accessToken,
				name: req.profileObj.name,
				avatar: req.profileObj.imageUrl,
				type: 'google',
				google: req.profileObj,
				facebook: {}
			};

			// does not work with passport-local-mongoose
			// because User which register as Google/FB Auth does not have hash/salt fields
			// have to use passport-google/facebook-auth for logged-in
			// await AjaxHelper.postAPIWithCorsMode(`${stateObj.adminAppURL}/login`, param);
			socialSignIn(param);
		}
	};

	const socialSignIn = (account) => {
		AjaxHelper.invokeServerAPI('/api/socialLogin', account, (err, data) => {
			if (err) {
				UIHelper.showErrorMessage(TranslationHelper.getValue('customer_account.login.socialerror'));
			} else {
				handleSignIn(data);
			}
		});
	};

	useEffect(() => {
		let isMounted = true;
		(async () => {
			const config = await AjaxHelper.invokeServerAPIPromise('/api/config', {
				'customer_account.googleClientID': 1,
				'customer_account.facebookClientID': 1,
				policies: 1,
				'customer_account.verify': 1,
				'stripe.publishableKey': 1,
				adminAppURL: 1
			});
			const paymentConfig = await AjaxHelper.invokeServerAPIPromise('/api/screenDesign', {
				screenName: 'Customer_Login'
			});
			const customerAttributes = await AjaxHelper.invokeServerAPIPromise('/api/customAttributes');
			const customerLogin = await AjaxHelper.invokeServerAPIPromise('/api/customerLogin');
			let user = SessionHelper.getSessionUser();
			if (!user) SessionHelper.removeUser();
			let profile;
			try {
				profile = await AjaxHelper.invokeServerAPIPromise('/api/profile/get');
				SessionHelper.saveSessionUser(profile);
				user = SessionHelper.getSessionUser();
			} catch (e) {
				SessionHelper.removeUser();
				user = null;
			}
			if (isMounted) {
				setStateObj((prevState) => ({
					...prevState,
					googleOauthAPIKey: config['customer_account.googleClientID'],
					facebookAPI: config['customer_account.facebookClientID'],
					termsAndConditions: config.policies ? config.policies.TermsandConditions.value : null,
					privacyPolices: config.policies ? config.policies.PrivacyPolicies.value : null,
					verificationRequired: config['customer_account.verify'],
					adminAppURL: config.adminAppURL,
					loginLayout: customerLogin
				&& customerLogin.result
				&& customerLogin.result.customerLogin
				&& customerLogin.result.customerLogin.layout
						? customerLogin.result.customerLogin.layout
						: null,
					facebookEnabled: customerLogin
				&& customerLogin.result
				&& customerLogin.result.customerLogin
						? customerLogin.result.customerLogin.loginAttributes.facebookEnabled
						: null,
					googleEnabled: customerLogin
				&& customerLogin.result
				&& customerLogin.result.customerLogin
						? customerLogin.result.customerLogin.loginAttributes.googleEnabled
						: null,
					stripeKey: config['stripe.publishableKey'],
					paymentEnabled: (paymentConfig.loginAttributes && paymentConfig.loginAttributes.paymentEnabled)
				|| false,
					customerAttributes: customerAttributes && customerAttributes.customAttributes,
					loggedIn: !!user,
					username: user ? profile.username : null,
					email: user ? profile.email : null
				}));
			}

			// if (user) {
			// 	console.log('hey');
			// 	const profile = await AjaxHelper.invokeServerAPIPromise('/api/profile/get');
			// 	setStateObj((prevState) => ({
			// 		...prevState,
			// 		loggedIn: true,
			// 		username: profile.username,
			// 		email: profile.email
			// 	}));
			// } else {
			// 	SessionHelper.removeUser();
			// }
		})();
		return () => { isMounted = false; };
	}, []);

	const social = (
		!stateObj.facebookEnabled && !stateObj.googleEnabled
			? null
			:			(
				<>
					{stateObj.googleOauthAPIKey && stateObj.googleEnabled
						? (
							<GoogleLogin
								clientId={stateObj.googleOauthAPIKey}
								onSuccess={(res) => {
									onGoogleLogin(res);
								}}
								onFailure={(res) => {
									console.log('error login into Google::', res);
								}}
								autoLoad={false}
								disabled={stateObj.googleOauthAPIKey.length === 0}
								render={(renderProps) => (
									<Button
										id={toggleSignUp ? 'ga-signUpWithGoogleAuth' : ''}
										className={toggleSignUp ? 'ga-signUp' : ''}
										onClick={renderProps.onClick}
										fullWidth
										style={{ margin: '10px 0px', color: 'white', backgroundColor: '#4081ec' }}
										variant="contained"
									>
										<i className="fab fa-google fa-2x" style={{ marginRight: '10px' }} />
										{toggleSignUp ? 'Sign up with Google' : 'Sign in with Google'}
									</Button>
								)}
							/>
						)
						: null}
					{stateObj.facebookAPI && stateObj.facebookEnabled
						? (
							<FacebookLogin
								isDisabled={stateObj.facebookAPI.length === 0}
								appId={stateObj.facebookAPI}
								autoLoad={false}
								fields="name,email,picture"
								callback={(res) => {
									onFacebookSignIn(res);
								}}
								render={(renderProps) => (
									<Button
										id={toggleSignUp ? 'ga-signUpWithFacebookAuth' : ''}
										className={toggleSignUp ? 'ga-signUp' : ''}
										onClick={renderProps.onClick}
										fullWidth
										style={{ margin: '10px 0px', color: 'white', backgroundColor: '#4267B2' }}
										variant="contained"
									>
										<i className="fab fa-facebook-square fa-2x" style={{ marginRight: '10px' }} />
										{toggleSignUp ? 'Sign up with Facebook' : 'Sign in with Facebook'}
									</Button>
								)}
							/>
						)
						: null}
					{stateObj.googleOauthAPIKey
					&& stateObj.facebookAPI
						? (
							<DividerWithText>
								{TranslationHelper.getValue('customer_account.modal.span.or')}
							</DividerWithText>
						) : null}
				</>
			)
	);

	const signIn = (
		<div className="signup-modal text-center">
			<LockOutlined style={{
				fill: 'white',
				backgroundColor: theme.palette.primary.main,
				borderRadius: '50%',
				padding: '10px',
				fontSize: '50px',
				marginBottom: '10px'
			}}
			/>
			<h3>Sign in</h3>
			{social}
			<form onSubmit={handleSubmit(onSignIn)}>
				{inputFieldsSignIn.map((input) => (
					<ReactHookFormInput
						key={input.name}
						{...{
							...input,
							useFormHooks
						}}
					/>
				))}
				<div style={{ margin: '5px 0px' }}>
					<a
						href="#/"
						onClick={(e) => { e.preventDefault(); setToggleForgotPass(true); }}
						style={{ cursor: 'pointer', textAlign: 'left' }}
					>
						{TranslationHelper.getValue('customer_account.modal.button.forgotPassword')}
					</a>
				</div>
				<Button
					fullWidth
					autoFocus
					style={{ margin: '10px 0px', color: 'white' }}
					variant="contained"
					color="primary"
					type="submit"
					data-cy="submitSignIn"
				>
					{TranslationHelper.getValue('customer_account.modal.button.signIn')}
				</Button>
				<div style={{ marginTop: '5px' }}>
					<a
						href="#/"
						onClick={(e) => { e.preventDefault(); setToggleSignUp(true); }}
						style={{ cursor: 'pointer' }}
						data-cy="switchToSignUp"
					>
						Dont have an account? Sign up
					</a>
				</div>
			</form>
		</div>
	);

	const forgotPass = (
		<div className="signup-modal text-center">
			<LockOutlined style={{
				fill: 'white',
				backgroundColor: theme.palette.primary.main,
				borderRadius: '50%',
				padding: '10px',
				fontSize: '50px',
				marginBottom: '10px'
			}}
			/>
			<h3>Password Reset</h3>
			<form onSubmit={handleSubmit(onForgotPass)}>
				<ReactHookFormInput
					{...{
						...{
							name: 'forgotPassEmail',
							label: 'Email Address',
							type: 'text',
							validation: { required: true },
							defaultValue: '',
							fullWidth: true,
							style: { margin: '10px 0px' },
							variant: 'outlined',
						},
						useFormHooks
					}}
				/>
				<Button
					fullWidth
					style={{ margin: '10px 0px', color: 'white' }}
					variant="contained"
					color="primary"
					type="submit"
				>
					{TranslationHelper.getValue('customer_account.modal.button.resetPassword')}
				</Button>
				<div style={{ marginTop: '5px' }}>
					<a
						href="#/"
						onClick={(e) => { e.preventDefault(); setToggleForgotPass(false); }}
						style={{ cursor: 'pointer' }}
					>
						Back to Sign In
					</a>
				</div>
			</form>
		</div>
	);

	const policy = (
		<div className="policy-text text-center" data-cy="policy">
			{(policyName === 'terms') && renderHTML(stateObj.termsAndConditions)}
			{(policyName === 'privacy') && renderHTML(stateObj.privacyPolices)}
		</div>
	);

	return (
		<div className="login-signup-modal">
			<ProfileMenu
				loggedIn={stateObj.loggedIn}
				loginLayout={stateObj.loginLayout}
				handleOpenSignIn={handleOpenSignIn}
				handleSignOut={handleSignOut}
				mobileView={mobileView}
				adminAppURL={stateObj.adminAppURL}
			/>
			<Modal
				open={openSignIn}
				onClose={handleCloseSignIn}
				disableScrollLock
				style={{ overflow: 'scroll' }}
			>
				{toggleSignUp ? (
					<SignUpForm
						social={social}
						handleSubmit={handleSubmit}
						handleOpenPolicy={handleOpenPolicy}
						setToggleSignUp={setToggleSignUp}
						onSignUp={onSignUp}
						stripe={stripePromise}
						paymentEnabled={stateObj.paymentEnabled}
						customerAttributes={stateObj.customerAttributes}
						loginLayout={stateObj.loginLayout}
					/>
				) : toggleForgotPass ? forgotPass : signIn}
			</Modal>
			<Dialog
				open={openPolicy}
				onClose={handleClosePolicy}
				scroll="body"
				PaperProps={{
					style: { borderRadius: 10 }
				}}
				TransitionComponent={Slide}
			>
				{policy}
			</Dialog>
		</div>
	);
};
export default SignUp;
